import { Alpine } from "../../../vendor/livewire/livewire/dist/livewire.esm";
import libs from "../frop/libs.js";

Alpine.data('TypesenseSearch', ({query, config, play = false}) => ({
  query: query || '',
  play,
  lastExecutedQuery: '',
  config: Object.assign({
    collection: 'public',
    type_filters: {
      articles: 'Artikler',
      episodes: 'Episoder',
      news_broadcasts: 'Nyhedsudsendelser',
      series: 'Serier',
    },
    highlight_full_fields: ['content'],
  }, config),
  results: [],
  loading: false,
  error: false,
  filters: [],
  searched: false,
  currentPage: 1,
  totalPages: 0,
  totalFound: 0,
  perPage: 10,
  types: {
    articles: 'Artikel',
    episodes: 'Episode',
    series: 'Serie',
    news_broadcasts: 'Nyhedsudsendelse',
    reels: 'Video',
  },
  client: null,
  init() {
    libs.Typesense.then(Typesense => {
      this.client = new Typesense.Client({
        nodes: [{
          host: this.config.host,
          port: 443,
          protocol: 'https'
        }],
        apiKey: this.config.api_key,
      });
      
      // Hvis play er aktiv, fjern "articles" fra starten
      if (this.play) {
        this.filters.push(...Object.keys(this.config.type_filters).filter(type => type !== 'articles'));
      }

      this.search();
    });
  },
  search() {
    if (!this.client || !this.query.trim()) return;
    this.results = [];
    if ('URLSearchParams' in window) {
      const url = new URL(window.location);
      url.searchParams.set("q", this.query);
      history.pushState(null, '', url);
    }
    this.performSearch(1);
  },
  performSearch(page) {
    this.loading = true;
    this.error = false;
    this.currentPage = page;
    this.lastExecutedQuery = this.query;
    this.client.collections(this.config.collection).documents().search(this.buildQuery({'page': page}))
    .then(response => {
      this.results = this.results.concat(response.hits);
      this.totalFound = response.found;
      this.totalPages = Math.ceil(response.found / this.perPage);
      this.searched = true;
      this.loading = false;
    })
    .catch(err => {
      console.error('Search error:', err);
      this.error = true;
      this.loading = false;
    });
  },
  /* reset() {
    if ('URLSearchParams' in window) {
      const url = new URL(window.location);
      url.searchParams.delete('q', this.query);
      history.pushState(null, '', url);
    }
    this.query = '';
    this.results = [];
    this.loading = false;
    this.error = false;
    this.filters = [];
    this.searched = false;
    this.currentPage = 1;
    this.totalPages = 0;
    this.totalFound = 0;
  }, */
  buildQuery(opts) {
    const query = Object.assign({}, opts, {
      q: this.query,
      per_page: this.perPage,
      preset: this.config.search_options?.preset,
      highlight_full_fields: this.config.highlight_full_fields.join(),
      highlight_affix_num_tokens: 2000,
      highlight_start_tag: '<mark class="py-1 text-inherit bg-yellow box-decoration-clone">',
      highlight_end_tag: '</mark>',
    }, this.buildFilters());
    return query;
  },
  buildFilters() {
    if (!this.filters.length) return {};
    return {
      filter_by: `type:=[${this.filters.join()}]`
    };
  },
  toggleFilter(filter) {
    if (this.filters.includes(filter)) {
      this.filters = this.filters.filter(value => value !== filter);
    } else {
      this.filters.push(filter);
    }
    this.search();
  },
  clearFilters() {
    this.filters = [];
    this.search();
  },
  loadPage(page) {
    this.performSearch(page);
  },
  formatDate(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('da-DK', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  },
}));